<template>
<div style="margin:5px;">
      <Row>
       <div class="backTo">
         <span v-on:click="back">&lt;&lt;返回</span>
      </div>
    </Row>
      <br>
          <Row><Col span="12" offset="10"><div class="myTitle" >{{title}}</div></Col></Row>
        <br>
      <Row >
          <Col span="5" offset="19">
            <div>
             统计日期： {{createTime}}
            </div>
          </Col>
      </Row>
      <br>
      <Row>
          <Col span="24">
              <Table :loading="loading" @on-selection-change="selectRow" 
                border ref="table" stripe :columns="columns4" :data="listData">
              
              </Table>
          </Col>
      </Row>
      <Row>
        <Col span="24">
          <div>
            <Footer>
              <Page show-sizer show-total :total="rowCount" :current="current"
                :page-size="pageSize"  @on-change="changePage"
                @on-page-size-change="changeSize" />
            </Footer>
          </div>
        </Col>
    </Row>
 
</div>
</template>

<script>


  export default {
    components: {
      
    },
    methods: {
    
      selectRow(selection) {
        this.selectRows = selection;
      },
    
      
      loadPage() {
         this.loading = false
        let url   = `api/report/get_report_detail_data`
        this.req({
          url: url,
          method: 'post',
          data:{
            p: this.current,
            pageSize: this.pageSize,
            _id:this._id
          }
        }).then(resp => {
          this.buildPageData(resp.data.page)
          this.loading = false
        }).catch(error => {
          this.$Message.error('服务器错误2:' + error);
        })
      },
      changePage(curPage) {
        this.loading = true
        this.current = curPage
        this.loadPage()
      },

      changeSize(pageSize) {
        this.pageSize = pageSize
        this.loading = true
        this.loadPage()
      },
      buildPageData(dataObj) {
        this.listData = dataObj.list;
        this.pageSize = dataObj.size;
        this.rowCount = dataObj.rowCount;
        this.currentPage = dataObj.p;
      },
     
      queryBtn(){
                this.current = 1
                this.loadPage()
      },
       //返回上一层  
      back(){  
          this.$router.go(-1);
      },
     
     
    },
    mounted: function () {
     	this.title=this.$route.query.title
      this._id =this.$route.query._id
      this.createTime =this.$route.query.createTime
      this.loadPage();
       this.loading = false
    },
    data() {
      return {
        listData: [],
        pageSize: 10,
        current: 1,
        rowCount: 0,
        loading: true,
        createTime:'',
        title: '',
        _id: '',
        columns4: [{
            type: 'index',
            title:'序号',
            width: 80,
            align: 'center',
          },
          {
            title: '标题',
            align: 'center',
            key: 'title',
          },
           {
            title: '链接地址',
            align: 'center',
            key: 'url',
          },
           {
            title: '来源',
            align: 'center',
            key: 'source',
          },          
          {
            title: '供应商',
            align: 'center',
            key: 'supplierInfo',
          },
         
        ],
      
      }
    },

  }
</script>

<style scoped>

 .backTo{
       margin:10px 30px; 
       color: blue;
       cursor: pointer;
    }
 
  .a {
    color: #fff;
  }
   .myTitle{
      font-size: 20px;
      font-weight: 700;
  }
</style>


// WEBPACK FOOTER //
// src/pages/platform/report/OtherNum.vue